import axios from "axios";
import { Result } from "@/models/Result";
import { requestConfig } from "./ApiService";
import ConfigService from "../ConfigService";

export default {
	getTikTokConnectData(companyId?: number, checklistClientId?: number, message?: string): Promise<Result> {
		return new Promise((resolve, reject) => {
			const url = new URL(ConfigService.tiktokConnectDataUrl);
			const config = {
				...requestConfig,
				params: {
					checklistClientId,
					companyId,
					message,
				}
			};
			axios
				.post(url.toString(), null, config)
				.then((response) => {
					const result: Result = response.data;
					resolve(result);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},

	loginCustomer(companyId: number): Promise<Result> {
		return new Promise((resolve, reject) => {
			const url = new URL(ConfigService.tiktokLoginCustomerUrl);

			const w = 850;
			const h = 800;
			const dualScreenLeft = window.screenLeft ?? window.screenX;
			const dualScreenTop = window.screenTop ?? window.screenY;
			const width = window.innerWidth || document.documentElement.clientWidth || screen.width;
			const height = window.innerHeight || document.documentElement.clientHeight || screen.height;
			const systemZoom = width / window.screen.availWidth;
			const left = (width - w) / 2 / systemZoom + dualScreenLeft
			const top = (height - h) / 2 / systemZoom + dualScreenTop

			const win = window.open(url + "?companyId=" + companyId, "windowname1", "width=" + w / systemZoom + ", height=" + h / systemZoom + ", top=" + top + ", left=" + left);
			const checkWinClosed = setInterval(function () {
				if (win && win.closed) {
					clearInterval(checkWinClosed);
					const result: Result = {
						Message: "",
						Success: true,
					};
					resolve(result);
				}
			}, 200);
		});
	},

	sendConnectMessage(email: string, clientName: string, msg: string): Promise<Result> {
		return new Promise((resolve, reject) => {
			const url = new URL(ConfigService.tiktokSendConnectMessageUrl);
			const config = {
				...requestConfig,
				params: {
					clientName,
					email,
					msg,
				}
			};
			axios
				.post(url.toString(), null, config)
				.then((response) => {
					resolve({
						Message: response.data.message,
						Success: response.data.success,
					});
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
